module.exports = __webpack_public_path__ + "static/media/1 12 sjal.2f3a5a52.mp3";